<template>
  <div v-if="!note_id" class="medical-history"><p>상담건이 없습니다.</p></div>
  <div v-else class="medical-history" :note_id="note_id">
    <div v-if="note.status!=9" class="history-client">
      <h3>추가 구매</h3>
      <p class="notice">{{ note.comment }}</p>
      <p class="notice-red margin-top-10">(※ 약품 종류, 가격 사전 안내 통화 필수)</p>
      <h3>약제비 / 배송비 청구 <span class="signup-notice">* 결제상태 : {{consult_status }}</span></h3>
      <div v-if="note.status < 4">
            <input type="checkbox" name="chk-no-price" id="chk-no-price" v-model="no_price" @click="chk_no_price" :disabled="note.status==4 || note.status==5">
            <label for="chk-no-price" class="txt-no-price">청구할 금액이 없습니다.</label>
      </div>
      <div class="profile-txt profile-txt-rt margin-bottom-10">
        <consult-price @set-consult-price="setConsultPrice" @set-item-price="setItemPrice" @set-delivery-price="setDeliveryPrice" :s_price="note" :no_price="no_price" :note_status="note_status" :delivery_object="delivery_object" :delivery_type="note.delivery_type" v-model="consult_price_items"></consult-price>
      </div>
    </div>
    <div class="note-cont">
      <button v-if="note.status==1 || note.status==2 || note.status==3" type="button" class="btn-submit" @click="addPrice" :disabled="!is_click">청구하기</button>
      <!-- <p v-if="note.status==3" class="signup-notice-red">* 약제비/배송비 결제대기 상태입니다.</p> -->
      <p v-if="note.status==4 || note.status==5" class="signup-notice-red">* 약제비/배송비가 수납되어 재청구할 수 없습니다.</p>
      <p v-if="note.status==9" class="signup-notice-red signup-notice-left">* 약조제/약배송이 취소되어 (재)청구할 수 없습니다.</p>
    </div>
    <!-- <div v-if="note.status==4 || note.status==5" class="history-client"> -->
    <div v-if="note.status>=4" class="history-client">
      <h3>복약 지도 및 코멘트</h3>
      <div class="user-cont">
        <div class="note-cont">
          <textarea autocomplete="off" v-model="user_guidance" @keyup.enter.prevent />
          
        </div>
        <div class="img-area">
          <div class="add-interior-thumb clearfix">
              <!-- 이미지가 있고 pdf 파일일때 -->
              <span v-if="image_yn && my_reply.img_url.includes('pdf')" @click="pdf_click(my_reply.img_url)" class="thumbnail">
                  <a class="icon-remove" @click.prevent="deleteImage(1)"><icon name="times-rectangle"></icon></a>
                  <pdf :src="my_reply.img_url" alt="" ></pdf>
              </span>

              <!-- <span @click="pdf_click(`https://drtest.mdsqr.com/static/dr_web/msg/2181/2181_9efd.pdf`)" class="thumbnail">
                  <pdf :src="`https://drtest.mdsqr.com/static/dr_web/msg/2181/2181_9efd.pdf`" alt="" ></pdf>
              </span> -->
              <!-- <span @click="pdf_click(`https://s3.ap-northeast-2.amazonaws.com/image.mdtalk.io/node/test/static/dr_web/msg/2181/2181_485a.pdf`)" class="thumbnail">
                  <pdf :src="`https://s3.ap-northeast-2.amazonaws.com/image.mdtalk.io/node/test/static/dr_web/msg/2181/2181_485a.pdf`" alt="" ></pdf>
              </span> -->
              <!-- https://drtest.mdsqr.com/static/dr_web/msg/2181/2181_9efd.pdf -->
              <!-- https://s3.ap-northeast-2.amazonaws.com/image.mdtalk.io/node/test/static/dr_web/msg/2181/2181_485a.pdf -->

              <!-- 이미지가 있고 pdf 파일이 아닐때 -->
              <span v-if="image_yn && !my_reply.img_url.includes('pdf')" class="thumbnail">
                  <a class="icon-remove" @click.prevent="deleteImage(1)"><icon name="times-rectangle"></icon></a>
                  <img :src="my_reply.img_url" alt="" @click="img_click(my_reply.img_url)">
              </span>

              <button v-if="image_yn" type="button" class="btn-submit" @click="deleteImage(1)">삭제</button>
              <span v-if="!image_yn" class="thumbnail-btn add-interior-thumb-upload">
                  <a @click.prevent="selectImage()"><span>+</span></a>
                  <input type="file" name="image" ref="fileInput" style="display: none" @change="uploadImage" />
              </span>
          </div>
          <div><span class="signup-notice-blue">(jpg, jpeg, png, gif, pdf)</span><div class="note-cont"><button type="button" class="btn-submit" @click="send_user" :disabled="!is_click">전송</button></div></div>  
        </div>   
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment-timezone';
  import URLS from '@/lib/urls'
  import Upload from '@/lib/upload'
  import {UPLOAD_TYPE, STATUS_CODE} from '@/lib/constants'
  import { defaultCoreCipherList } from 'constants';
  import { nameByConstMixin } from '@/lib/mixins'

  import ConsultPrice from '@/components/ConsultPharm/ConsultPrice.vue'
  
  import pdf from 'vue-pdf'

  export default {
    mixins: [nameByConstMixin],
    name: 'consult-pharm-payment',
    props: ['note_id', 'note', 'note_status'],
    data () {
      return {
        pharmacy: {},
        consult_price_items: [],
        consult_price: 0,
        consult_status: '',
        is_click: true,
        is_doc_click: true,
        no_price: false,
        attach_urls : [],
        url_web : '',
        check_url_data: null,
        fax_doc: '',
        image_yn: false,
        my_reply : {},
        is_submit: false,
        is_fax_doc: false,

        delivery_object: {
          delivery_price: this.note.delivery_type == '2' ? 4000 : 3500, //배송료 금액
          delivery_name: '배송료',
        },
        // pharmacy_price_items: [],
        // pharmacy_price: 0,
        // pharmacy_status: '',
        user_guidance: '',
        attach_url: '',
        attach_name: '',
      }
    },
    computed: {
        ...mapState(['account']),       
    },
    methods: {
      selectImage(){
        // console.log("selectImage().....")
        this.$refs.fileInput.click()
      },
      async uploadImage(event){
        // console.log("uploadImage().....", event);

        var file_obj = event.target.files[0]

        // TODO 
        // key_id와 resize_width 현재값으로 보내는게 문제 없는지 체크
        // UPLOAD_TYPE 뭘로 해야되는지
        // let upload = new Upload(UPLOAD_TYPE.APP_IMG, {key_id:this.note_id, resize_width:400})
        let upload = new Upload(UPLOAD_TYPE.MSG_ATTACH, {key_id:this.note_id, resize_width:400})

        upload.append(file_obj);
        //console.log("uploadImage() file_obj", file_obj.name);

        let resp = await upload.done()

        var uploaded_file_url = resp.uploaded_files[0][1];

        //console.log("uploaded_file_url = " + uploaded_file_url);
        //console.log("uploaded_sm_file_url = " + uploaded_sm_file_url);

        /***************************************************/
        // TODO img_url은 내화면에 보이기위한 전체 URL
        // 주의 : URLS.WEB에 마지막에 "/"가 안붙어있음. 다른 url들은 붙어있음. 꼭 체크
        // upload를 msg 타입으로 하고 있음. 다른 타입으로 할 경우 url 변경 필요
        //this.my_reply.img_url = URLS.WEB + "/static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        this.my_reply.img_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + uploaded_file_url;
        // attach_url = 서버에 전송하기 위한 URL
        this.my_reply.attach_url = uploaded_file_url;
        this.my_reply.attach_name = file_obj.name;
        this.image_yn = true;

        // this.imageExist = true;
        // return resp.uploaded_sm_files;

      },
      deleteImage(){
        //console.log("deleteImage().....");
        this.my_reply.img_url = null;
        this.my_reply.attach_url = "";
        this.my_reply.attach_name = "";
        this.image_yn = false;
      },
      async img_click(url, index) { 
        this.check_url_data = index;
        this.fax_doc = url;
        let routeData = this.$router.resolve(`/imageview?image_url=${url}`);
        this.popupCenter(routeData.href, "image_view", 600, 800, 0, 200);
        
      },
      pdf_click(url, index) { 
        this.check_url_data = index;
        this.fax_doc = url;
        // console.log("url = " + url);
        let img_detail = window.open(url,"pdf_detail","width=850,height=1000");
      },
      async chk_no_price() {
        this.no_price = !this.no_price;
        this.consult_price_items = [];
        if(this.no_price) {
          this.consult_price_items.push("약제비^0");
          this.delivery_object.delivery_name = "배송료";
          this.delivery_object.delivery_price = 0;
          // this.note.consult_price = 0;
        } else {
          this.load_content(this.note_id);
          this.delivery_object.delivery_name = "배송료";
          this.delivery_object.delivery_price = this.note.delivery_type == '2' ? 4000 : 3500;          
        }
      },
      async addPrice() {
        // if(!this.consult_price || this.consult_price==0) {
        let submit_text = "* 약종류, 가격 안내를 하셨나요?\n----------------------------------------------";
          
        let item = '';
        let price = '';
        let sum = 0;
        let price_value = this.consult_price_items.slice();

        if(this.delivery_object.delivery_price && this.delivery_object.delivery_price > 0) 
          price_value.push(this.delivery_object.delivery_name + "^" + this.delivery_object.delivery_price);

        for(let i=0;i<price_value.length;i++) {
          if(price_value[i]) {
            item = price_value[i].split('^')[0];
            price = price_value[i].split('^')[1];

            submit_text = submit_text + "\n  - " + item + " : " + price + "원";
            sum = sum + Number(price);
          }
        }

        if(sum == 0 && !this.no_price) {
          alert('비용을 입력하셔야 합니다.');
          return;
        } else if(this.consult_price > 1000000) {
          alert('비용은 1,000,000원을 넘을 수 없습니다. \n관리자에게 연락해 주세요.');
          return;
        }

        this.consult_price = sum;

        submit_text = submit_text + "\n----------------------------------------------"
        submit_text = submit_text + "\n                            합계 : " + sum + "원\n----------------------------------------------"
        submit_text = submit_text + "\n위 내용으로 청구하시겠습니까?";

        if(confirm(submit_text)) {
          this.is_click = false;
          
          if(this.delivery_object.delivery_price && this.delivery_object.delivery_price > 0)
            this.consult_price_items.push(this.delivery_object.delivery_name + "^" + this.delivery_object.delivery_price);

          // console.log('addPrice consult_price_items', this.consult_price_items);
          
          let body_price = {
            pharmacy_price: this.consult_price,
            pharmacy_price_items: this.consult_price_items,
            // is_payment: 1, //1:빌링결제 성공 0:실패
          };
          let {data} = await this.axios.post(`consult_note/delivery_price/${this.note_id}`, body_price)

          if (data.status === STATUS_CODE.OK) {

            let reply_push = "";
            let alert_push = "";
            let return_status = 1;
            if(!this.no_price) { //본인 부담금이 있거나 추가서류 청구금액이 있을경우
              // 빌링처리 
              alert_push = "약제비가 청구되었습니다.";
              reply_push = "약제비가 청구되었습니다. 약조제 내용 확인 후 [결제동의] 확인해 주세요.";
              return_status = 2;
            } else { //본인부담금이 없고 추가서류 청구 금액도 없을경우
              alert_push = "본인부담금 없이 약제비가 처리되었습니다.\n조제내용을 등록해 주세요.";
              reply_push = "본인부담금없이 약제비가 처리되었습니다. 조제 후 배송을 진행합니다."
              return_status = 4;
            }

            await this.$emit('reload_list', return_status);

            let post_data = {
              push_title: `약국 알림\n(${this.account.pharm_name})`, 
              push_msg: reply_push, 
              push_dr_id:this.account.pharm_id, 
              push_uid:this.note.uid,
              push_consult_type:9,
              push_send_type:6
            } 
            let {data} = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data);
            
            this.is_click = true;
          } else if (data.status === STATUS_CODE.OK) {  // 빌링 실패 시 

            if(!this.no_price) { //본인 부담금이 있거나 추가서류 청구금액이 있을경우
              alert('약제비 청구에 실패하였습니다. 수동으로 결제대기 중입니다.');
            }
            await this.$emit('reload_list', 3);

            let reply_push = "약제비 결제 실패. 상세화면에서 다른 카드로 결제 바랍니다."
            let post_data = {
              push_title: `약국조제 알림\n(${this.account.pharm_name})`, 
              push_msg: reply_push, 
              push_dr_id:this.account.pharm_id, 
              push_uid:this.note.uid,
              push_consult_type:9,
              push_send_type:6
            } 
            
            let {data} = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data);
            
            this.is_click = true;
          } else {
            alert(data.msg)
            await this.$emit('reload_list', 1);
            this.is_click = true;
            // this.load_content(this.note_id);
          }
        } else {

        }
      },
      async send_user() {
        if(this.note_status < 4) {
          alert('약제비 청구 및 결제완료 후 전송해 주세요.');
          let post_data = {
            push_title: `약국 알림 \n(${this.account.pharm_name})`, 
            push_msg: '배송 신청하신 약조제를 위해 진료 상세화면에서 [결제동의]를 진행해 주세요.',
            push_dr_id:this.account.pharm_id, 
            push_uid:this.note.uid,
            push_consult_type: 9,
            push_send_type: 6
          }

          let { data } = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data)

          if (data.status === STATUS_CODE.OK) {
            alert('환자에게 결제진행 처리 메세지를 보냈습니다.')
          } else {
            alert('메세지 송신 에러: ' + data.msg);
          }
          return;

        } else if(!this.user_guidance || this.user_guidance.trim() == "") {
          alert('복약지도 내용을 입력해 주세요.');
          this.user_guidance = '';
          return;
        } 

        this.is_click = false;
          
        let parmas = {
          note_id: this.note.note_id,
          user_guidance: this.user_guidance,
          pharmacy_status: 5, //조제완료
          attach_url: this.my_reply.attach_url,
          attach_name: this.my_reply.attach_name,
        };
        let {data} = await this.axios.post(`/consult_pharm/update`, parmas)

        if (data.status === STATUS_CODE.OK) {
          alert('조제완료 처리하여 사용자에게 전송되었습니다.');
          await this.$emit('reload_list', 5);

          let reply_push = "처방약 조제가 완료되어 배송을 준비 중입니다.";

          let post_data = {
            push_title: `약국 알림\n(${this.account.pharm_name})`, 
            push_msg: reply_push, 
            push_dr_id:this.account.pharm_id, 
            push_uid:this.note.uid,
            push_consult_type:9,
            push_send_type:6
          } 
          let {data} = await this.axios.post(`consult_note/${this.note.note_id}/push`, post_data);
          
        } else {
           alert('조제완료 처리 시 오류가 발생했습니다. 시스템 관리자에게 문의하세요.');
        }
        this.is_click = true;
      },
      setConsultPrice(price) {
        //alert('setConsultPrice:'+price)
        this.consult_price = price;
      },
      setItemPrice(price) {
        //alert('setConsultPrice:'+price)
        this.consult_price = price;
      },
      setDeliveryPrice(price) {
        //alert('setConsultPrice:'+price)
        this.delivery_object.delivery_price = price;
      },
      async load_content(note_id) {
        this.my_reply = {};
        this.image_yn = false;
        this.consult_price = 0;
        this.user_guidance = '';


        if(this.note.pharmacy_price_items) this.consult_price_items =  JSON.parse(this.note.pharmacy_price_items);
        else this.consult_price_items = [];

        if(this.note.pharmacy_price) this.consult_price =  this.note.pharmacy_price;

        if(this.note.user_guidance) this.user_guidance =  this.note.user_guidance;

        // console.log('load_content this.note.p_attach_url', this.note.p_attach_url);
        if(this.note.p_attach_url) {

          this.image_yn = true;
          this.my_reply.img_url = URLS.S3 + "static/dr_web/msg/" + this.note_id + "/" + this.note.p_attach_url;
          this.my_reply.attach_url = this.note.p_attach_url;
          this.my_reply.attach_name = this.note.p_attach_name;
        }

        // this.pharmacy = {};
        // let { data } = await this.axios.get(`pharmacy_info/${note_id}`)

        // if(data.status == "200"){
        //   let {resp} = data;
        //   this.pharmacy = Object.assign({}, this.pharmacy, resp)
        // } 
        // console.log('this.pharmacy', this.pharmacy);
        // console.log('this.pharmacy_name', this.pharmacy.pharmacy_name);
      },
      async load_consult_status() {
        //this.consult_status = this.note.status_name;
        if(this.note.status==1) this.consult_status = '청구전';
        else if(this.note.status<4) this.consult_status = '결제대기';
        else if(this.note.status==9) this.consult_status = '취소';
        else this.consult_status = '결제완료';
        // else if(this.note.status==5) this.consult_status = '조제완료';
        
      },
    },
    mounted () {
        //this.url_web = URLS.WEB;
        this.url_web = URLS.S3;

        // this.$log.debug('status', this.note.status, 'consultnotPayment')
        if(this.note_id) {
          this.load_content(this.note_id);
        }
    },
    watch: {
       note_id: function (note_id) {
        //console.log('pay note_id 변경됨(watch)', note_id)
        this.consult_price = 0;
        this.is_fax_doc = false;
        if(this.note.status == 1){
          this.delivery_object.delivery_price = this.note.delivery_type == '2' ? 4000 : 3500;
        }else{
          this.delivery_object.delivery_price = 0; // 청구알림 시 배송료를 0으로 세팅
        } 
        this.load_content(this.note_id);
        this.load_consult_status();
       },
       note_status: function (note_status) {
        //console.log('pay note_status 변경됨(watch)', note_status)
        if(this.note.status<note_status) this.note.status = note_status;
        if(note_status == 1){
          this.delivery_object.delivery_price = this.note.delivery_type == '2' ? 4000 : 3500; 
        } else{
          this.delivery_object.delivery_price = 0; // 청구알림 시 배송료를 0으로 세팅
        } 
        //  this.load_content(this.note_id);
        this.load_consult_status();
       },
    },
    components: {
      ConsultPrice, pdf
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

img {
    image-orientation: from-image;
}

    .medical-history > div {
        margin-bottom: 30px;
    }

    .medical-history h3 {
        color: #4c4c4c;
        margin-bottom: 10px;
        letter-spacing: -.5px;
        font: 500 16px 'Noto Sans KR', sans-serif;
    }

    .history-txt {
        width: 100%;
        padding: 12px 15px;
        box-sizing: border-box;
        background-color: #f5f6fa;
        font: 400 12px 'Noto Sans KR', sans-serif;
        min-height: 50px;
        word-wrap: break-word;
        word-break:keep-all;
    }

    .history-txt .cur-img{
      margin-right: 20px;
      text-align:left;
    }
    .history-txt .tot-img{
      margin-left: 110px;
      text-align:right;
    }
    .history-txt .change-img{
      cursor: pointer;
      text-align:left;
    }
    .history-txt .change-img-o{
      color: #f5f6fa;
      text-align:left;
    }
    
    .history-img {
      text-align: center;
      width: 200px;
      /* height: 300px; */
      /* margin-top: 10px; */
      background-color: #f5f6fa;
      min-height: 200px;
      transform: translateX(0px);
    }

    .history-client-list ul,
    .history-before-list ul{float: left;}

    .history-client-list li,
    .history-before-list li{
        margin-bottom: 10px;
        height: 20px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .history-client-list .client-lt,
    .history-before-list .before-lt{
        width: 120px;
        color: #b7b7b7;
    }

    .history-client-list .client-rt,
    .history-before-list .before-rt{
        width: 200px;
        color: #484848;
    }

    .rt-chat-input-wrap {
      width: 90%;
      height: 140px;
      padding: 15px 80px 15px 15px;
      box-sizing: border-box;
      position: relative;
      background-color: #f5f6fa;
    }

    .rt-chat-input-wrap > textarea {
      width: 95%;
      height: 100%;
      border: none;
      outline: 0;
      /* background-color: transparent; */
      resize : none;
    }

    .rt-chat-input-wrap > button {
      outline: 0;
      cursor: pointer;
      border: none;
      padding: 0;
      position: absolute;
    }

    .chat-btn {
    color: #fff;
    width: 50px;
    height: 30px;
    right: 20px;
    top: 20px;
    box-sizing: border-box;
    text-align: center;
    background-color: #5e71e9;
    font: 400 12px/30px 'Noto Sans KR', sans-serif;
  }

    /**********************************************/
    .note-title {
      color: #b7b7b7;
      margin-bottom: 10px;
      height: 20px;
      font: 400 12px 'Noto Sans KR', sans-serif;
    }
    .note-content {
      vertical-align: middle;
      color: #484848;
    }


    /**********************************************/
    /** 
     * 이미지 업로드
     */
    .thumbnail {
        /*padding:4px;*/
        border: 1px solid #ddd;
        display: inline-block;
        float:left;
        overflow: hidden;
        position:relative;
        line-height: 0;
      }

    .thumbnail img {
        width: 100%;
        height: 100%;
    }
    .thumbnail .icon-remove {
        position: absolute;
        left: 0;
        top: 0;
    }

    /*.thumbnail img {*/
        /*width: 100px;*/
        /*height: 100px;*/
      /*}*/

    /*.thumbnail-btn {*/
        /*display: inline-block;*/
        /*float:left;*/
        /*overflow: hidden;*/
        /*position:relative;*/
        /*padding: 6px 12px;*/
        /*border:1px solid #ddd;*/
        /*margin: 5px 0 0 10px;*/
        /*background-color: #bbb;*/
        /*border-radius: 10px;*/
        /*line-height: 25px;*/
        /*color: #fff;*/
      /*}*/

    .thumbnail-btn a {
        font-weight:bold;
        display: block;
        /*width: 100px;*/
        width: 100%;
        height: 100%;
        font-size: 12px
      }

    .add-interior-thumb {font-size: 0;}
    .add-interior-thumb span {
        float: left;
        width: 100px;
        height: 90px;
        margin: 0 10px 10px 0;
    }

    .add-interior-thumb p {
        float: left;
        width: 30px;
        /* margin: 5px 0 0 0; */
    }

    .add-interior-thumb-upload {
        display: inline-block;
        width: 120px;
        height: 90px;
        border: none;
        position: relative;
        border: 1px solid #999;
        background-color: transparent;
    }

    .add-interior-thumb-upload span {
        display: block;
        width: 35px;
        height: 35px;
        color: #999;
        position: absolute;
        text-align: center;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        border: 1px solid #999;
        transform: translate(-50%, -50%);
        font: 400 24px/35px 'Noto Sans KR', sans-serif;
    }
    /* 2019-08-09 추가 sh */
    .guest-info{
        margin-bottom:10px;
    }
    .guest-info dt,
    .guest-info dd{
      font:400 12px Noto Sans KR,sans-serif;
      /* min-height:20px; */
      margin-bottom:5px;
    }
    .guest-info dt{
      float:left;
      width:100px;
      margin-left:20px;
      margin-right:10px;
      color:#b7b7b7;
    }
    .guest-info dd{
      overflow:hidden;
      color:#484848;
    }
    .guest-info .data-info{
      display:inline-block;
      width:50%;
      vertical-align:top;
    }
    .answer{
      margin:0 10px 10px;
    }
    .answer .note-tt,
    .answer h4{
      margin-bottom:10px;
      font-weight:bold;
    }
    .answer .note-tt .date{
      float:right;
    }
    .answer .note-cont{
      padding:10px;
      background:#f5f6fa;
      text-align:right;
    }
    .answer .note-cont textarea{
      display:block;
      width:100%; 
      height:150px;
      padding:10px;
      font:400 12px Noto Sans KR,sans-serif;
      text-align:left;
      word-break:keep-all;
      box-sizing:border-box;
      -webkit-box-sizing:border-box;
    }
    .answer .note-cont .btn-submit{
      width:100px;
      height:25px;
      /* line-height:32px; */
      padding:0;
      margin:0;
      border:0;
      background:#5e71e9;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
    }
    .answer .note-cont .history-txt{
      text-align:left;
      padding:0px 10px;
      min-height:0;
      word-break:keep-all;
    }


    .answer .note-cont .signup-notice {
        text-align:left;
        color: #afafaf;
        margin: 0;
        font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .img-area{
      margin-top:-10px;
      padding:12px 15px;
      background:#f5f6fa;
    }
    
    .user-info-btn {
      float: right;
      padding: 5px;
      cursor:pointer;
    }

    /* The Modal (background) */
    .modal {
        display: block; /* Hidden by default */
        position: fixed; /* Stay in place */
        opacity:0.99;
        z-index: 100; /* Sit on top */
        padding-top: 80px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(9,9,9); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        position: relative;
        background-color: #fefefe;
        margin: auto;
        padding: 0;
        border: 1px solid #888;
        width: 350px;
        overflow-y: auto;
        /* overflow: hidden; */
        box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
        -webkit-animation-name: animatetop;
        -webkit-animation-duration: 0.4s;
        animation-name: animatetop;
        animation-duration: 0.4s
    }

    /* Add Animation */
    @-webkit-keyframes animatetop {
        from {top:-300px; opacity:0} 
        to {top:0; opacity:1}
    }

    @keyframes animatetop {
        from {top:-300px; opacity:0}
        to {top:0; opacity:1}
    }

    /* The Close Button */
    .close {
        color: white;
        float: right;
        font-size: 30px;
        font-weight: bold;
    }

    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .modal-header h1 {
        margin-bottom: 10px;
        font: 400 20px 'Noto Sans KR', sans-serif;
    }

    .modal-header {
        padding: 10px 20px;
        background-color: #111;
        color: white;
    }

    .modal-body {padding: 10px 20px;}

    .modal-footer {
        padding: 2px 10px;
        background-color: #111;
        color: white;
    }

    .note-cont{
      padding:0px;
      text-align:right;
      margin-right: 20px;
      margin-top: 10px;
    }

    .btn-submit{
      width:120px;
      height:35px;
      /* line-height:30px; */
      padding:0;
      margin:0;
      border:0;
      background:#5e71e9;
      color:#fff;
      font:400 14px Noto Sans KR,sans-serif;
      font-weight:bold;
      cursor:pointer;
    }

    .notice {
      /* float: left; */
      color:#484848;
      margin-top: 10px;
      font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .notice-red {
        color: #ee0000;
        /* margin: 0; */
        margin-bottom: 10px;
        margin-left: 20px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .notice-blue {
        color: #0000ee;
        /* margin: 0; */
        margin-bottom: 10px;
        margin-left: 20px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .signup-notice {
      float: right;
      color:#484848;
      /* margin: 0; */
      margin-right: 20px;
      font: 400 14px 'Noto Sans KR', sans-serif;
    }

    .signup-notice-left {
      text-align:left;
    }

    .signup-notice-red {
        color: #ee0000;
        /* margin: 0; */
        margin-top: 40px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .signup-notice-blue {
        text-align:left;
        color: #0000ee;
        /* margin-left: 100px; */
        margin-top: 20px;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .chk-no-price {
        margin-top: 40px;
        padding-left: 5px;
        /* font: 400 14px 'Noto Sans KR', sans-serif; */
    }

    .txt-no-price {
        padding-left: 5px;
        font: 400 14px 'Noto Sans KR', sans-serif;
    } 

    .btn-send-doc{
      width:80px;
      height:30px;
      margin-left: 5px;
      line-height:32px;
      /* margin:0; */
      border:0;
      background:#666;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
    }    

    .btn-send {
      width:80px;
      height:30px;
      margin-left: 5px;
      line-height:32px;
      /* margin:0; */
      border:0;
      background:#5e71e9;
      color:#fff;
      font-weight:bold;
      cursor:pointer;
    }

    .date {
      width:150px;
      font:400 12px Noto Sans KR,sans-serif;
      float:right;
    }

    .user-cont .note-cont{
      margin:10px 0;
      padding:10px;
      background:#f5f6fa;
      text-align:right;
      word-break:keep-all;
    }

    .user-cont .note-cont textarea{
      display:block;
      width:100%; 
      height:60px;
      padding:10px;
      font:400 12px Noto Sans KR,sans-serif;
      text-align:left;
      word-break:keep-all;
      box-sizing:border-box;
      -webkit-box-sizing:border-box;
    }
    .user-cont .note-cont .history-txt{
      text-align:left;
      padding:0px 10px;
      min-height:0;
      word-break:keep-all;
    }

</style>
